(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.visible = false;
    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)
    this.calculateHeight = debounce(this.calculateHeight.bind(this), 100);
    this.hasSessionStorage = this.checkHasSessionStorage()
  }

  calculateHeight() {
    const targetHeight = this.visible ? this.querySelector('.announcement__inner').offsetHeight + 'px' : '0px'
    this.style.maxHeight = targetHeight;
    document.querySelector(':root').style.setProperty('--announcement-bar-height', targetHeight);
  }

  connectedCallback() {
    this.calculateHeight()

    const closeButton = this.querySelector('.announcement__close')
    if (closeButton) {
      closeButton.addEventListener('click', this.hide);
    }

    if (!closeButton || !this.hasSessionStorage) {
      window.setTimeout(this.show, 500);
      return;
    }

    if (this.hasSessionStorage && sessionStorage[this.dataset.text] !== 'hidden') {
      window.setTimeout(this.show, 500);
    }
  }

  show() {
    this.visible = true;
    this.calculateHeight();
    window.addEventListener('resize', this.calculateHeight);
  }

  hide() {
    if (this.hasSessionStorage) {
      sessionStorage.setItem(this.dataset.text, 'hidden');
    }

    this.visible = false;
    this.calculateHeight();
    window.removeEventListener('resize', this.calculateHeight)
  }

  checkHasSessionStorage = function() {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage = window.sessionStorage;
    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };


  disconnectedCallback() {
    window.removeEventListener('resize', this.calculateHeight)
  }
}

customElements.define('announcement-bar', AnnouncementBar);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    const okendoWidget = document.querySelector('[data-oke-widget]')
    if (okendoWidget) {
      const newNode = document.createElement("span");
      const parentNode = okendoWidget.parentNode;;
      newNode.className="h-0 w-0 block invisible relative -top-header";
      newNode.id = 'reviews';
      parentNode.prepend(newNode)
    }

    (function checkRecharge() {
      if (window.Recharge && document.querySelector('.rc-widget')) {
        const rechargeWidget = document.querySelector('.rc-widget')

        // Move Tooltip Content
        const tooltip = rechargeWidget.querySelector('.rc-subscription-details')

        const howItWorks = tooltip.querySelector('.how-it-works')
        const learnMore = tooltip.querySelector('.learn-more')
        const newNode = document.createElement("div");
        newNode.className = 'text-body-sm text-joint-green-light'
        const newLearnMore = learnMore.cloneNode(true)
        newLearnMore.classList.add('text-link')
        newLearnMore.setAttribute('href', '/policies/subscription-policy')
        newNode.innerHTML = howItWorks.innerHTML + ' '
        newNode.append(newLearnMore)
        tooltip.innerHTML = ''
        tooltip.append(newNode)

        // Percentage
        const subscription = rechargeWidget.querySelector('.rc-radio__subscription')
        const subscriptionText = subscription.textContent
        const percentString = subscriptionText.match(/[0-9]*\%/)[0]
        newSubscriptionText = subscriptionText.replace(percentString, '')
        subscription.textContent = newSubscriptionText

        const discount = document.createElement('span')
        discount.className = "flag flag--reverse flag--sm inline-flex ml-3"
        discount.textContent = percentString + ' Savings'

        subscription.parentNode.append(discount)

      } else {
        setTimeout(checkRecharge, 200)
      }
    })()
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features-list"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-features-list')) {
  class ProductFeaturesList extends HTMLElement {
    constructor() {
      super();
      this.threshold = 50 // Percentage of vivewport height measured from the top
      this.observing = false
      this.elements = {
        line: this.querySelector('.product-features-list__line'),
        items: this.querySelectorAll('.product-features-list__item'),
        images: this.querySelectorAll('.product-features-list__image'),
        itemsRoot: this.querySelector('.product-features-list__list-root'),
        emblaWrapper: this.querySelector('embla-wrapper')
      }
      this.bindEvents()
    }

    onEmblaSelect() {
      const embla = this.elements.emblaWrapper.embla
      const selectedIndex = embla.selectedScrollSnap()
      this.elements.images.forEach((image, index) => {
        if (selectedIndex == index) {
          this.elements.images[index].classList.remove('opacity-0',)
          this.elements.images[index].classList.add('opacity-1')
        } else {
          this.elements.images[index].classList.remove('opacity-1',)
          this.elements.images[index].classList.add('opacity-0')
        }
      })
    }

    handleItemIntersection = (entries, observer) => {
      entries.forEach(entry => {
        const index = entry.target.dataset.index
        const inner = entry.target.querySelector('.product-features-list__item-inner')

        if (entry.isIntersecting) {
          inner.classList.remove('opacity-40', 'blur-xs')
          inner.classList.add('opacity-1')
          this.elements.images[index].classList.remove('opacity-0',)
          this.elements.images[index].classList.add('opacity-1')
        } else {
          inner.classList.remove('opacity-1')
          inner.classList.add('opacity-40', 'blur-xs')
          if (index == 0) return;
          this.elements.images[index].classList.remove('opacity-1',)
          this.elements.images[index].classList.add('opacity-0')
        }
      })
    }

    updateLine() {
      const maxHeight = this.elements.items[this.elements.items.length - 1].offsetTop - this.elements.items[0].offsetTop
      const viewportHeight = window.innerHeight
      const startpoint = this.elements.line.offsetTop + this.elements.line.parentElement.getBoundingClientRect().top
      const endpoint = viewportHeight * this.threshold / 100
      var lineHeight = endpoint - startpoint
      lineHeight = Math.max(0, lineHeight)
      lineHeight = Math.floor(Math.min(maxHeight, lineHeight))
      this.elements.line.style.height = lineHeight + 'px'
    }

    handleRootIntersection = (entries, observer) => {
      if (entries[0].isIntersecting) {
        // Create timer
        if (!this.timer) this.timer = setInterval(this.updateLine, 10)
      } else {
        // Destroy timer to avoid unnecessary checks
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }
    }

    bindEvents() {
      this.updateLine = this.updateLine.bind(this)
      this.onEmblaSelect = this.onEmblaSelect.bind(this)
      this.handleRootIntersection = this.handleRootIntersection.bind(this)
      this.handleItemIntersection = this.handleItemIntersection.bind(this)
      this.resize = debounce(this.resize, 100).bind(this)
    }

    connectedCallback() {
      this.resize()
      window.addEventListener('resize', this.resize)
    }


    observe() {
      if (this.observing) return;
      this.rootObserver = new IntersectionObserver(this.handleRootIntersection)
      this.rootObserver.observe(this.elements.itemsRoot)

      this.itemObserver = new IntersectionObserver(this.handleItemIntersection, {rootMargin: `0% 0% -${ 100 - this.threshold }% 0%`})
      this.elements.items.forEach(item => {
        this.itemObserver.observe(item);
      })
      this.observing = true
    }
    unobserve() {
      if (!this.observing) return;
      if (this.itemObserver) {
        this.elements.items.forEach(item => {
          this.itemObserver.unobserve(item);
        })
      }
      if (this.rootObserver) {
        this.rootObserver.unobserve(this.elements.itemsRoot);
      }
      this.observing = false
    }

    mobile() {
      this.unobserve()
      const embla = this.elements.emblaWrapper.embla
      if (embla) embla.on('select', this.onEmblaSelect)
    }

    desktop () {
      this.observe()
      const embla = this.elements.emblaWrapper.embla
      if (embla) embla.off('select', this.onEmblaSelect)
    }

    resize() {
      if (window.innerWidth >= 768) {
        this.desktop()
      } else if (window.innerWidth < 768) {
        this.mobile()
      }
    }

    disconnectedCallback() {
      this.unobserve()
      window.removeEventListener('resize', this.resize)
    }

  }
  customElements.define('product-features-list', ProductFeaturesList);
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-features')) {
  class ProductFeatures extends HTMLElement {
    constructor() {
      super();
      this.observing = false
      this.threshold = 70 // Percentage of vivewport height measured from the top
      this.mobileElements = {
        items: this.querySelectorAll('.product-features__mobile__item'),
        line: this.querySelector('.product-features__mobile__line'),
      }
      this.desktopElements = {
        itemsWrapper: this.querySelector('.product-features__desktop'),
        items: this.querySelectorAll('.product-features__desktop__item')
      }
      this.bindEvents()
    }

    bindEvents() {
      this.updateLine = this.updateLine.bind(this)
      this.handleRootIntersection = this.handleRootIntersection.bind(this)
      this.handleItemIntersection = this.handleItemIntersection.bind(this)
      this.resize = debounce(this.resize, 100).bind(this)
      this.onScroll = throttle(this.onScroll, 100).bind(this)
    }

    resize() {
      if (window.innerWidth >= 1024) {
        if (this.observing) {
          this.unobserve()
        }
        window.addEventListener('scroll', this.onScroll)
      } else if (window.innerWidth < 1024){
        window.removeEventListener('scroll', this.onScroll)
        if (!this.observing) {
          this.observe()
        }
      }
    }

    connectedCallback() {
      this.resize()
      window.addEventListener('resize', this.resize)
    }

    disconnectedCallback() {
      this.unobserve()
      window.removeEventListener('resize', this.resize)
      window.removeEventListener('scroll', this.onScroll)
    }

    // Desktop

    onScroll() {
      const boundingRect = this.getBoundingClientRect()
      const windowHeight = window.innerHeight;
      const timelineHeight = boundingRect.height - windowHeight
      const offsetTop = boundingRect.top
      const items = this.desktopElements.items
      const nElements = items.length
      const interval = timelineHeight / (nElements)
      items.forEach((el, index) => {
        const trigger = (index * interval) * -1
        if (offsetTop < trigger) {
          el.classList.remove('opacity-0')
        } else {
          el.classList.add('opacity-0')
        }
      })
    }

    // Mobile

    handleItemIntersection = (entries, observer) => {
      entries.forEach(entry => {
        const inner = entry.target.querySelector('.product-features__mobile__item-inner')
        if (entry.isIntersecting) {
          inner.classList.remove('opacity-40', 'blur-xs')
          inner.classList.add('opacity-1')
        } else {
          inner.classList.remove('opacity-1')
          inner.classList.add('opacity-40', 'blur-xs')
        }
      })
    }

    updateLine() {
      const maxHeight = this.mobileElements.items[this.mobileElements.items.length - 1].offsetTop - this.mobileElements.items[0].offsetTop
      const viewportHeight = window.innerHeight
      const startpoint = this.mobileElements.line.offsetTop + this.mobileElements.line.parentElement.getBoundingClientRect().top
      const endpoint = viewportHeight * this.threshold / 100
      var lineHeight = endpoint - startpoint
      lineHeight = Math.max(0, lineHeight)
      lineHeight = Math.floor(Math.min(maxHeight, lineHeight))
      this.mobileElements.line.style.height = lineHeight + 'px'
    }

    handleRootIntersection = (entries, observer) => {
      if (entries[0].isIntersecting) {
        // Create timer
        if (!this.timer) this.timer = setInterval(this.updateLine, 10)
      } else {
        // Destroy timer to avoid unnecessary checks
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }
    }

    observe() {
      this.rootObserver = new IntersectionObserver(this.handleRootIntersection)
      this.rootObserver.observe(this)

      this.itemObserver = new IntersectionObserver(this.handleItemIntersection, {rootMargin: `0% 0% -${ 100 - this.threshold }% 0%`})
      this.mobileElements.items.forEach(item => {
        this.itemObserver.observe(item);
      })

      this.observing = true
    }

    unobserve() {
      if (this.itemObserver) {
        this.mobileElements.items.forEach(item => {
          this.itemObserver.unobserve(item);
        })
      }
      if (this.rootObserver) {
        this.rootObserver.unobserve(this);
      }
      this.observing = false
    }
  }
  customElements.define('product-features', ProductFeatures);
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-and-save"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('subscribe-and-save')) {
  class SubscribeAndSave extends HTMLElement {
    constructor() {
      super();
      this.threshold = 60 // Percentage of vivewport height measured from the top
      this.elements = {
        line: this.querySelector('.subscribe-and-save__line'),
        items: this.querySelectorAll('.subscribe-and-save__item'),
      }
      this.bindEvents()
    }

    handleItemIntersection = (entries, observer) => {
      entries.forEach(entry => {
        const inner = entry.target.querySelector('.subscribe-and-save__item-inner')
        if (entry.isIntersecting) {
          inner.classList.remove('opacity-40', 'blur-xs')
          inner.classList.add('opacity-1')
        } else {
          inner.classList.remove('opacity-1')
          inner.classList.add('opacity-40', 'blur-xs')
        }
      })
    }

    updateLine() {
      const maxHeight = this.elements.items[this.elements.items.length - 1].offsetTop - this.elements.items[0].offsetTop
      const viewportHeight = window.innerHeight
      const startpoint = this.elements.line.offsetTop + this.elements.line.parentElement.getBoundingClientRect().top
      const endpoint = viewportHeight * this.threshold / 100
      var lineHeight = endpoint - startpoint
      lineHeight = Math.max(0, lineHeight)
      lineHeight = Math.floor(Math.min(maxHeight, lineHeight))
      this.elements.line.style.height = lineHeight + 'px'
    }

    handleRootIntersection = (entries, observer) => {
      if (entries[0].isIntersecting) {
        // Create timer
        if (!this.timer) this.timer = setInterval(this.updateLine, 10)
      } else {
        // Destroy timer to avoid unnecessary checks
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }
    }

    bindEvents() {
      this.updateLine = this.updateLine.bind(this)
      this.handleRootIntersection = this.handleRootIntersection.bind(this)
      this.handleItemIntersection = this.handleItemIntersection.bind(this)
    }

    create() {
      this.rootObserver = new IntersectionObserver(this.handleRootIntersection).observe(this)

      this.itemObserver = new IntersectionObserver(this.handleItemIntersection, {rootMargin: `0% 0% -${ 100 - this.threshold }% 0%`})
      this.elements.items.forEach(item => {
        this.itemObserver.observe(item);
      })
    }

    connectedCallback() {
     this.create()
    }

    disconnectedCallback() {
      if (this.itemObserver) {
        this.elements.items.forEach(item => {
          this.itemObserver.unobserve(item);
        })
      }
      if (this.rootObserver) {
        this.rootObserver.unobserve(this);
      }
    }

  }
  customElements.define('subscribe-and-save', SubscribeAndSave);
}



  } catch(e) { console.error(e); }
})();
})();
